export default __webpack_public_path__ + "static/media/imgDarkEn2.34d29186.png";